

(function () {
  if (window.__vm) return; window.__vm = 1;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var EASE = 'cubic-bezier(.22,1,.36,1)';
  var DUR = 1600;
  var DUR_TITULO = 1800;
  var DUR_FOTO = 2200;
  var PASO = 110;
  var MAX_PASOS = 8;
  var RECORRIDO = 14;

  var SALTAR = '#heroe, .heroe, [class*="hero"], .pdp-compra, .pdp-zoom, .pz, .marquesina, #sellos, header, dialog, [hidden], .visualmente-oculto, .resenas, #frentes, #progreso';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var st = document.createElement('style');
  st.id = 'vm-css';
  st.textContent =
    '.vm .vm-pre{opacity:0}' +
    '.vm-l{display:block;overflow:hidden;padding-bottom:.12em;margin-bottom:-.12em}' +
    '.vm-l>span{display:block}' +
    '.vm .semana{overflow:hidden}';
  document.head.appendChild(st);
  document.documentElement.classList.add('vm');

  var vh = innerHeight;

  var claimed = new Set();
  var libre = function (el) {
    if (!el || claimed.has(el)) return false;
    for (var p = el.parentElement; p; p = p.parentElement) if (claimed.has(p)) return false;
    var hijos = Array.from(claimed);
    for (var i = 0; i < hijos.length; i++) if (el.contains(hijos[i])) return false;
    return true;
  };
  var visibleYAbajo = function (el) {
    if (!el.getClientRects().length) return false;
    if (el.closest(SALTAR)) return false;
    return el.getBoundingClientRect().top > vh * 0.9;
  };

  var reg = new Map();
  var lanzar = function (triggers) {
    var items = [];
    triggers.forEach(function (t) {
      io.unobserve(t);
      items = items.concat(reg.get(t) || []);
      reg.delete(t);
    });
    items.sort(function (a, b) {
      return a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    var n = 0;
    items.forEach(function (it) {
      var delay = it.fixed ? it.extra : Math.min(n++, MAX_PASOS) * PASO + it.extra;
      play(it, delay);
    });
  };
  var io = new IntersectionObserver(function (entries) {
    lanzar(entries.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; }));
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

  var alFinal = function () {
    if (!reg.size || innerHeight + scrollY < document.documentElement.scrollHeight - 4) return;
    var h = innerHeight, ts = [];
    reg.forEach(function (_, t) { if (t.getBoundingClientRect().top < h) ts.push(t); });
    if (ts.length) lanzar(ts);
  };
  addEventListener('scroll', alFinal, { passive: true });

  var luminancia = function (color) {
    var m = color.match(/[\d.]+/g);
    if (!m || m.length < 3) return null;
    var a = m.length > 3 ? parseFloat(m[3]) : 1;
    if (a < 0.85) return null;
    var c = function (v) { v /= 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    return 0.2126 * c(+m[0]) + 0.7152 * c(+m[1]) + 0.0722 * c(+m[2]);
  };

  var detrasOscuro = function (el) {
    for (var q = el.parentElement; q && q !== document.body; q = q.parentElement) {
      var L = luminancia(getComputedStyle(q).backgroundColor);
      if (L !== null) return L < 0.35;
    }
    return false;
  };

  var add = function (el, kind, trigger, extra, fixed) {
    if (!libre(el)) return;

    if (el.closest && el.closest('[data-sk], .sk-ancla')) return;

    if (detrasOscuro(el) &&
        (kind === 'foto' || el.tagName === 'IMG' ||
         el.tagName === 'PICTURE' || el.tagName === 'FIGURE')) return;
    claimed.add(el);
    trigger = trigger || el;
    if (kind === 'nada' || !visibleYAbajo(trigger)) return;
    prep(el, kind);
    if (!reg.has(trigger)) reg.set(trigger, []);
    reg.get(trigger).push({ el: el, kind: kind, extra: extra || 0, fixed: !!fixed });
    io.observe(trigger);
  };

  var prep = function (el, kind) {
    if (kind === 'fade') el.classList.add('vm-pre');
    if (kind === 'foto') el.style.clipPath = 'inset(100% 0 0 0)';
    if (kind === 'titulo') {
      var outer = document.createElement('span'); outer.className = 'vm-l';
      var inner = document.createElement('span');
      while (el.firstChild) inner.appendChild(el.firstChild);
      outer.appendChild(inner); el.appendChild(outer);
      inner.style.translate = '0 105%';
      el.__vmInner = inner;
    }
  };

  var play = function (it, delay) {
    var el = it.el;
    if (it.kind === 'fade') {
      el.classList.remove('vm-pre');
      el.animate([{ opacity: 0, translate: '0 ' + RECORRIDO + 'px' }, { opacity: 1, translate: '0 0' }],
        { duration: DUR, delay: delay, easing: EASE, fill: 'backwards' });
    }
    if (it.kind === 'titulo') {
      var inner = el.__vmInner;
      inner.animate([{ translate: '0 105%' }, { translate: '0 0' }],
        { duration: DUR_TITULO, delay: delay, easing: EASE, fill: 'forwards' })
        .finished.then(function () { inner.style.translate = '0 0'; });
    }
    if (it.kind === 'foto') {
      el.animate([{ clipPath: 'inset(100% 0 0 0)', scale: 1.06 }, { clipPath: 'inset(0% 0 0 0)', scale: 1 }],
        { duration: DUR_FOTO, delay: delay, easing: EASE, fill: 'forwards' })
        .finished.then(function () { el.style.clipPath = ''; });
    }
  };

  var esTituloSimple = function (h) {
    if (getComputedStyle(h).display !== 'block') return false;
    return Array.from(h.children).every(function (c) {
      return c.tagName === 'BR' || getComputedStyle(c).display.indexOf('inline') === 0;
    });
  };

  var desplazaEnHorizontal = function (el) {
    var cs = getComputedStyle(el);
    return /auto|scroll/.test(cs.overflowX) || el.scrollWidth > el.clientWidth + 4;
  };

  var sem = $('.semanas');
  if (sem) {
    var cols = getComputedStyle(sem).gridTemplateColumns.split(' ').length;
    $$('.semana', sem).forEach(function (s, i) {
      var d = cols > 1 ? i * 220 : 0;

      [$('.semana__titulo', s)].concat($('.semana__texto > *', s)).forEach(function (t, j) {
        add(t, 'fade', s, d + j * 140, true);
      });
    });
  }

  var caja = $('.comparativa__caja');
  if (caja) add(caja, 'fade');

  var fig = $('.calidad__media');
  var fotoCalidad = fig && $('img', fig);
  if (fotoCalidad) {
    if (parseFloat(getComputedStyle(fig).borderRadius) === 0) fig.style.borderRadius = getComputedStyle(fotoCalidad).borderRadius;
    fig.style.overflow = 'hidden';
    add(fotoCalidad, 'foto', fig);
    fotoCalidad.style.scale = '1.08';
  }
  $$('.calidad__entrada').forEach(function (e) { add(e, 'fade', $('.calidad__lista')); });

  $$('.pdp-vet__foto, .pdp-plazo__foto img').forEach(function (img) { add(img, 'foto'); });

  $$('main ul, main ol, footer ul').forEach(function (list) {
    if (list.closest(SALTAR)) return;
    var lis = Array.from(list.children).filter(function (li) { return li.tagName === 'LI'; });
    if (lis.length < 2) return;

    var carrusel = desplazaEnHorizontal(list) || (list.parentElement && desplazaEnHorizontal(list.parentElement));
    lis.forEach(function (li, i) {
      add(li, i < 10 ? 'fade' : 'nada', carrusel ? list : li);
    });
  });

  $$('main h1, main h2').forEach(function (h) {
    add(h, esTituloSimple(h) ? 'titulo' : 'fade');
  });

  $$('main :is(h3, p, blockquote, table, figure, picture, img, video, details, form, .boton, .carta__firma), footer :is(.pie__columna, .pie__inferior p)')
    .forEach(function (el) {
      if (el.tagName === 'IMG' && el.getBoundingClientRect().width < 120) return;
      add(el, 'fade');
    });

  $$('.quiz__pantalla').forEach(function (p) {
    new MutationObserver(function () {
      if (p.hidden) { p.__vmVisto = false; return; }
      if (p.__vmVisto) return;
      p.__vmVisto = true;
      Array.from(p.children).filter(function (c) { return !c.hidden && c.getClientRects().length; })
        .forEach(function (c, i) {
          c.animate([{ opacity: 0, translate: '0 10px' }, { opacity: 1, translate: '0 0' }],
            { duration: 1200, delay: i * 90, easing: EASE, fill: 'backwards' });
        });
    }).observe(p, { attributes: true, attributeFilter: ['hidden'] });
  });
  var barra = $('.quiz__barra-hecho');
  if (barra && getComputedStyle(barra).transitionDuration === '0s') {
    barra.style.transition = 'width 1.2s ' + EASE + ', transform 1.2s ' + EASE;
  }

  var px = [];
  if (fotoCalidad) px.push([fig, function (p) { fotoCalidad.style.translate = '0 ' + ((p - 0.5) * -28).toFixed(1) + 'px'; }]);
  var pr = 0;
  var onScroll = function () {
    if (pr || !px.length) return;
    pr = requestAnimationFrame(function () {
      pr = 0; var h = innerHeight;
      px.forEach(function (x) {
        var r = x[0].getBoundingClientRect();
        if (r.bottom < -100 || r.top > h + 100) return;
        x[1](Math.min(1, Math.max(0, (h - r.top) / (h + r.height))));
      });
    });
  };
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

(function () {
  if (window.__vmMicro) return; window.__vmMicro = 1;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  var contador = document.querySelector('[data-carrito-contador]');
  var enviando = [];

  function soltar(hecho) {
    enviando.forEach(function (b) {
      b.classList.remove('vm-enviando');
      if (hecho && !reduce) {
        b.classList.remove('vm-hecho'); void b.offsetWidth; b.classList.add('vm-hecho');
      }
    });
    enviando = [];
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('.pdp-compra__form, .producto__compra')) return;
    var b = f.querySelector('button[type="submit"], .boton');
    if (!b) return;
    b.classList.add('vm-enviando');
    enviando.push(b);
    setTimeout(function () { soltar(false); }, 4000);
  }, true);

  if (contador) {
    var antes = contador.textContent;
    new MutationObserver(function () {
      var ahora = contador.textContent;
      if (ahora === antes) return;
      var subio = Number(ahora) > Number(antes || 0);
      antes = ahora;
      if (!subio) return;
      if (!reduce) {
        contador.classList.remove('vm-latido'); void contador.offsetWidth; contador.classList.add('vm-latido');
      }
      soltar(true);
    }).observe(contador, { childList: true, characterData: true, subtree: true });
  }

  var cajon = document.getElementById('carrito');
  if (cajon && !reduce) {
    var abierto = cajon.classList.contains('abierto');
    new MutationObserver(function () {
      var ahora = cajon.classList.contains('abierto');
      if (ahora && !abierto) {
        Array.prototype.slice.call(cajon.querySelectorAll('.linea:not([hidden])'), 0, 6).forEach(function (li, i) {
          li.animate([{ opacity: 0, translate: '0 10px' }, { opacity: 1, translate: '0 0' }],
            { duration: 900, delay: 180 + i * 70, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
        });
      }
      abierto = ahora;
    }).observe(cajon, { attributes: true, attributeFilter: ['class'] });
  }
})();

(function () {
  if (window.__vmA11y) return; window.__vmA11y = 1;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function t(k, respaldo) {
    var s = window.VEVVIA_I18N && window.VEVVIA_I18N.t(k);
    return s && s !== k ? s : respaldo;
  }
  var CARRUSELES = [
    ['.fichas__carril', '.ficha', 'a11y.ingredientes', 'Ingredientes. Usa las flechas para verlos todos'],
    ['.resenas__ventana', '.resenas__diapo', 'a11y.resenas', 'Reseñas de clientes. Usa las flechas para pasar'],
    ['.videos__pista', 'li', 'a11y.videos', 'Vídeos de clientes. Usa las flechas para pasar']
  ];
  function montar() {
    CARRUSELES.forEach(function (c) {
      Array.prototype.forEach.call(document.querySelectorAll(c[0]), function (el) {
        if (el.__vmTeclado) return; el.__vmTeclado = 1;
        el.classList.add('vm-teclado');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
        if (!el.hasAttribute('aria-label')) el.setAttribute('aria-label', t(c[2], c[3]));
        el.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var item = el.querySelector(c[1]);
          var paso = item ? item.getBoundingClientRect().width : el.clientWidth * 0.8;
          el.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * paso, behavior: reduce ? 'auto' : 'smooth' });
          e.preventDefault();
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', montar); else montar();
  if (window.VEVVIA_I18N && window.VEVVIA_I18N.listo && window.VEVVIA_I18N.listo.then) {
    window.VEVVIA_I18N.listo.then(function () {

      CARRUSELES.forEach(function (c) {
        Array.prototype.forEach.call(document.querySelectorAll(c[0] + '.vm-teclado'), function (el) {
          el.setAttribute('aria-label', t(c[2], c[3]));
        });
      });
    });
  }
})();
